"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var icons_1 = require("@tiendanube/icons");

var InteractiveListPriv_RadioItem_1 = __importDefault(require("./InteractiveListPriv.RadioItem"));

var InteractiveListPriv_ActionItem_1 = __importDefault(require("./InteractiveListPriv.ActionItem"));

var InteractiveListPriv_CheckItem_1 = __importDefault(require("./InteractiveListPriv.CheckItem"));

require("./InteractiveListPriv.css");

var __1 = require("..");

function InteractiveListPriv(_a) {
  var children = _a.children,
      addItemLabel = _a.addItemLabel,
      skeleton = _a.skeleton,
      onClickAddItem = _a.onClickAddItem;
  var mainClass = classnames_1.default("nimbus--interactive-list-wrapper");
  return React.createElement("div", {
    className: mainClass
  }, addItemLabel && React.createElement("div", {
    className: "nimbus--interactive-list__add-item"
  }, React.createElement("div", {
    className: "nimbus--interactive-list-item"
  }, skeleton ? React.createElement(__1.Link.Skeleton, null) : React.createElement(__1.Link, {
    onClick: onClickAddItem,
    appearance: "primary",
    icon: icons_1.PlusCircleIcon
  }, addItemLabel))), React.createElement("div", {
    className: "nimbus--interactive-list",
    role: "list"
  }, children));
}

InteractiveListPriv.ActionItem = InteractiveListPriv_ActionItem_1.default;
InteractiveListPriv.CheckItem = InteractiveListPriv_CheckItem_1.default;
InteractiveListPriv.RadioItem = InteractiveListPriv_RadioItem_1.default;
exports.default = InteractiveListPriv;